import HeaderTypes from "../Domain/Types/HeaderTypes";
import {CONNECTION_STATUS_TIMINGS_MILLISECONDS} from "./Parameters";

/**
 * Returns the header titles.
 * @param headerTypes The header type.
 */
export const HEADER_TITLES = (headerTypes: HeaderTypes): string =>
{
    switch (headerTypes)
    {
        case HeaderTypes.ClientName:
            return "Client Name";
        case HeaderTypes.ConnectionStatus:
            return "Connection Status";
        case HeaderTypes.ProxyName:
            return "Proxy Name";
        case HeaderTypes.ProxyId:
            return "Proxy Id";
        case HeaderTypes.None:
        default:
            return "";
    }
}

/**
 * Message to show if user is not logged in.
 */
export const IS_NOT_LOGGED_IN = "You will need to log in\nto perform this action.";

/**
 * Messages for the power action modals.
 */
export const POWER_ACTION_MESSAGES = {
    noClientSelected: "No client selected.\nSelect at least one to perform this action.",
    wakeSuccess: "Successfully sent the wake request to the server!",
    wakeFailed: "Failed to send the wake request to the server due to the following issue:",
    shutdownSuccess: "Successfully sent the shutdown request to the server!",
    shutdownFailed: "Failed to send the shutdown request to the server due to the following issue:",
}

/**
 * The primary title.
 */
export const PRIMARY_TITLE = "Urban Playground Power System Controller";

/**
 * Power Client screen name.
 */
export const POWER_CLIENTS_DASHBOARD_TITLE = "Power Clients Dashboard";

/**
 * Power Proxy screen name.
 */
export const POWER_PROXY_DASHBOARD_TITLE = "Power Proxies Dashboard";

/**
 * Fetch success title.
 */
export const FETCHING_SUCCESS_TITLE = "Updating...";

/**
 * Fetch failed title.
 */
export const FETCHING_FAILED_TITLE = `Update Failed. Retrying in ${CONNECTION_STATUS_TIMINGS_MILLISECONDS.interval / 1000} seconds...`;

/**
 * Token expired message.
 */
export const EXPIRED_TOKEN = "Session expired. You have been logged out. Log in again to continue."